module.exports = __webpack_public_path__ + "static/media/Home_Top-img.55152d83.svg";